import lazyLoading from './lazyLoading'

export default {
  name: 'Resident Management',
  path: '/resident',
  redirect: '/resident/apt',
  meta: {
    auth: ['user'],
    group: ['admin', 'homenet-dev'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('house', true),

  children: [
    {
      name: 'PartnerList',
      path: 'partnerlist',
      meta: {
        label: 'Partner List',
        auth: ['user'],
        group: ['admin'] // check cognito group, only visible for this group
      },
      component: lazyLoading('house/PartnerList')
    },
    {
      name: 'MyPartner',
      path: 'partnerinfo',
      meta: {
        label: 'My Partner Info',
        auth: ['user'],
        group: ['homenet-dev']
      },
      component: lazyLoading('house/MyPartner')
    },
    {
      name: 'ComplexManagement',
      path: 'complex',
      meta: {
        label: 'Complex Management',
        auth: ['user'],
        group: ['homenet-dev']
      },
      component: lazyLoading('house/ComplexList')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/house.js